/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _dispatcher = require("../../../dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _MatrixClientPeg = require("../../../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _AccessibleButton = require("../elements/AccessibleButton");

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _RoomAvatar = require("../avatars/RoomAvatar");

var _RoomAvatar2 = _interopRequireDefault(_RoomAvatar);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_ROOMS = 20;

var RoomBreadcrumbs = function (_React$Component) {
    (0, _inherits3.default)(RoomBreadcrumbs, _React$Component);

    function RoomBreadcrumbs(props) {
        (0, _classCallCheck3.default)(this, RoomBreadcrumbs);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RoomBreadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(RoomBreadcrumbs)).call(this, props));

        _this.state = { rooms: [] };
        _this.onAction = _this.onAction.bind(_this);
        _this._previousRoomId = null;
        _this._dispatcherRef = null;
        return _this;
    }

    (0, _createClass3.default)(RoomBreadcrumbs, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            this._dispatcherRef = _dispatcher2.default.register(this.onAction);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            _dispatcher2.default.unregister(this._dispatcherRef);
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var _this2 = this;

            var rooms = this.state.rooms.slice();
            if (rooms.length) {
                var _rooms$ = rooms[0],
                    room = _rooms$.room,
                    animated = _rooms$.animated;

                if (!animated) {
                    rooms[0] = { room: room, animated: true };
                    setTimeout(function () {
                        return _this2.setState({ rooms: rooms });
                    }, 0);
                }
            }
        }
    }, {
        key: "onAction",
        value: function onAction(payload) {
            switch (payload.action) {
                case 'view_room':
                    if (this._previousRoomId) {
                        this._appendRoomId(this._previousRoomId);
                    }
                    this._previousRoomId = payload.room_id;
            }
        }
    }, {
        key: "_appendRoomId",
        value: function _appendRoomId(roomId) {
            var room = _MatrixClientPeg2.default.get().getRoom(roomId);
            if (!room) {
                return;
            }
            var rooms = this.state.rooms.slice();
            var existingIdx = rooms.findIndex(function (r) {
                return r.room.roomId === room.roomId;
            });
            if (existingIdx !== -1) {
                rooms.splice(existingIdx, 1);
            }
            rooms.splice(0, 0, { room: room, animated: false });
            if (rooms.length > MAX_ROOMS) {
                rooms.splice(MAX_ROOMS, rooms.length - MAX_ROOMS);
            }
            this.setState({ rooms: rooms });
        }
    }, {
        key: "_viewRoom",
        value: function _viewRoom(room) {
            _dispatcher2.default.dispatch({ action: "view_room", room_id: room.roomId });
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            // check for collapsed here and
            // not at parent so we keep
            // rooms in our state
            // when collapsing and expanding
            if (this.props.collapsed) {
                return null;
            }
            var rooms = this.state.rooms;
            var avatars = rooms.map(function (_ref, i) {
                var room = _ref.room,
                    animated = _ref.animated;

                var isFirst = i === 0;
                var classes = (0, _classnames2.default)({
                    "mx_RoomBreadcrumbs_preAnimate": isFirst && !animated,
                    "mx_RoomBreadcrumbs_animate": isFirst
                });
                return _react2.default.createElement(
                    _AccessibleButton2.default,
                    { className: classes, key: room.roomId, title: room.name, onClick: function onClick() {
                            return _this3._viewRoom(room);
                        } },
                    _react2.default.createElement(_RoomAvatar2.default, { room: room, width: 32, height: 32 })
                );
            });
            return _react2.default.createElement(
                "div",
                { className: "mx_RoomBreadcrumbs" },
                avatars
            );
        }
    }]);
    return RoomBreadcrumbs;
}(_react2.default.Component);

exports.default = RoomBreadcrumbs;
module.exports = exports["default"];
//# sourceMappingURL=RoomBreadcrumbs.js.map